<template>
  <span v-if="isList" class="corp-tag-chips">
    <v-chip v-for="tag in tags" :key="tag.id" :small="small" label outlined color="primary" class="corp-tag-chips__chip">
      {{ tag.name }}
    </v-chip>
    <span v-if="dash && !tags.length">—</span>
  </span>
</template>

<script>
// Теги корпа чипами. Поле tags сервер отдаёт только администратору: если его нет, не рисуем ничего
// (отсутствующее поле нельзя подменять пустым списком, у админа пустой список приходит как []).
export default {
  name: 'CorpTagChips',
  props: {
    tags: { type: Array, default: undefined },
    small: { type: Boolean, default: true },
    // Для списка: у админа без тегов показать «—»
    dash: { type: Boolean, default: false },
  },
  computed: {
    isList() {
      return Array.isArray(this.tags);
    },
  },
};
</script>

<style scoped lang="scss">
.corp-tag-chips {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;

  &__chip {
    margin: 0 !important;
  }
}
</style>
